module.exports = __webpack_public_path__ + "static/media/meat@3x.d3c10c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/meat@3x.png
// module id = 669
// module chunks = 1